import React, { SyntheticEvent } from 'react';

import { AriaWrappedButtonFactory } from './AriaWrappedButtonFactory';
import { useBubbleShield } from '../Hooks/useBubbleShield';
import { useForceFocus } from '../Hooks/useForceFocus';

export type ButtonAriaProps = React.PropsWithChildren<{
  tabindex: number,
  ref: React.MutableRefObject<HTMLButtonElement>,
}>;

export const ButtonAria = React.forwardRef((baseProps: any, baseRef) => {
  const actualRef = baseRef || baseProps.ref || React.useRef<HTMLButtonElement>(null);
  const props = {
    ...baseProps,
    'onClick': baseProps.onPress,
    'disabled': baseProps.isDisabled,
    'aria-disabled': baseProps.isDisabled,
    'tabIndex': baseProps.excludeFromTabOrder ? -1 : 0,
  };

  useForceFocus(actualRef, props.forceFocus);
  if(props.blurOnClick)
  {
    const origOnClick = props.onClick;
    props.onClick = (evt: SyntheticEvent) => {
      if(actualRef.current)
      {
        actualRef.current.blur();
      }
      if(origOnClick) {
        origOnClick(evt);
      }
    };
  }

  // Clean out these props.
  const {
    onPress,
    isDisabled,
    ref,
    excludeFromTabOrder,
    preventFocusOnPress,
    onPressStart,
    ...cleanProps
  } = props;

  return (
    <button
      { ...cleanProps }
      ref = { actualRef }
    >
      { baseProps.children }
    </button>
  );
});
  /*
  AriaWrappedButtonFactory('button', (props : ButtonAriaProps): JSX.Element => {
    //useBubbleShield(props.ref);

    return (
      <button
        { ...props }
        ref = { ref }
      >
        { props.children }
      </button>
    );
  })(props)
  */
